module.exports = __webpack_public_path__ + "img/img-news.2ffdd624.jpg";